import { render, staticRenderFns } from "./NotificationsSection.v2.vue?vue&type=template&id=2dff549d&scoped=true"
import script from "./NotificationsSection.v2.vue?vue&type=script&lang=js"
export * from "./NotificationsSection.v2.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSection.v2.vue?vue&type=style&index=0&id=2dff549d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff549d",
  null
  
)

export default component.exports